import React from "react";

export default function PlayButtonIcon() {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5 26C45.5 36.7696 36.7696 45.5 26 45.5C15.2304 45.5 6.5 36.7696 6.5 26C6.5 15.2304 15.2304 6.5 26 6.5C36.7696 6.5 45.5 15.2304 45.5 26ZM48 26C48 38.1503 38.1503 48 26 48C13.8497 48 4 38.1503 4 26C4 13.8497 13.8497 4 26 4C38.1503 4 48 13.8497 48 26ZM22.5 33.7942L34.5 26.866C35.1667 26.4811 35.1667 25.5189 34.5 25.134L22.5 18.2058C21.8333 17.8209 21 18.302 21 19.0718V32.9282C21 33.698 21.8333 34.1791 22.5 33.7942Z"
        fill="currentColor"
      />
    </svg>
  );
}
